import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./ExampleAR.css";

function ExampleAR() {
  // State to store link data
  const [links, setLinks] = useState({
    // Default values
    'CustomBanner': { type: 'website', url: 'heimdall-gallery.com/fr/project/oktober/' },
    'CustomBanner2': { type: 'website', url: 'heimdall-gallery.com/fr/project/solstorm/' },
    'CustomBanner4': { type: 'website', url: 'heimdall-gallery.com/fr/project/jotunheimen/' },
    'CustomBanner3': { type: 'instagram', username: 'art.lilou' },
    'CustomAction': { type: 'website', url: 'prophecy-xr.fr/exampe-ar' }
  });

  useEffect(() => {
    // Function to handle opening the appropriate link
    const openLink = (elementId) => {
      const linkData = links[elementId];
      
      if (!linkData) {
        console.error(`No link data found for ${elementId}`);
        return;
      }
      
      if (linkData.type === 'instagram') {
        // Open Instagram
        const username = linkData.username.replace('@', '');
        
        // Instagram deep link URL formats
        const instagramAppUrl = `instagram://user?username=${username}`; // Direct app URL
        const instagramWebUrl = `https://www.instagram.com/${username}/`; // Fallback web URL
        
        // Try to open the Instagram app first
        setTimeout(() => {
          // If we're still here after timeout, app didn't open, go to web
          window.location.href = instagramWebUrl;
        }, 2500);
        
        // Attempt to open the app
        window.location.href = instagramAppUrl;
      } else if (linkData.type === 'website') {
        // Open website
        let url = linkData.url;
        
        // Add https:// if not present
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
          url = 'https://' + url;
        }
        
        // Open the website in a new tab
        window.open(url, '_blank');
      }
    };

    // Function to handle the AR QuickLook button tap message
    const handleARMessage = (event) => {
      if (event.data === "_apple_ar_quicklook_button_tapped") {
        console.log("AR button was tapped!");
        
        // Find which element triggered this
        const elementId = event.currentTarget.id;
        console.log(`Button tapped with ID: ${elementId}`);
        
        // Open the appropriate link
        openLink(elementId);
      }
    };

    // Add the event listener to all AR links
    const arLinks = document.querySelectorAll("[rel='ar']");
    arLinks.forEach(link => {
      link.addEventListener("message", handleARMessage);
    });

    // Cleanup function to remove event listeners
    return () => {
      arLinks.forEach(link => {
        link.removeEventListener("message", handleARMessage);
      });
    };
  }, [links]);

  return (
    <div className="example-ar">
      <div className="ar-container">
        <div className="header-title">
          <h1>Prophecy</h1>
          <div className="xr-box">XR</div>
        </div>
        <div className="catch-phrase">
          Rajoutez un lien depuis votre site vers votre oeuvre en 1 clique
        </div>

        <div className="ar-content">
          <div className="ar-text">
            Cliquez sur l'une des image pour voir directement cette oeuvre chez
            vous avec les informations que vous souhaitez rajouter dans la
            bannière
            <div className="ar-image-container">
              <a
                rel="ar"
                id="CustomBanner2"
                href={`https://aelftmmytfogebtinoid.supabase.co/storage/v1/object/public/mvp//Oktober_marie_sandell.usdz#custom=https://axxou.github.io/host_html/&customHeight=medium`}
              >
                <img
                  src="https://aelftmmytfogebtinoid.supabase.co/storage/v1/object/public/mvp//Oktober_marie_sandell.jpg"
                  width="210"
                  height="210"
                  alt="AR Model Preview"
                />
              </a>
            </div>
            <div className="ar-image-container">
              <a
                rel="ar"
                id="CustomBanner2"
                href={`https://aelftmmytfogebtinoid.supabase.co/storage/v1/object/public/mvp//Solstorm.usdz#custom=https://axxou.github.io/host_html/&customHeight=medium`}
              >
                <img
                  src="https://aelftmmytfogebtinoid.supabase.co/storage/v1/object/public/mvp//solstorm.png"
                  width="225"
                  height="225"
                  alt="AR Model Preview"
                />
              </a>
            </div>
            <div className="ar-image-container">
              <a
                rel="ar"
                id="CustomBanner4"
                href={`https://aelftmmytfogebtinoid.supabase.co/storage/v1/object/public/mvp//jotunheimen.usdz#custom=https://axxou.github.io/host_html/&customHeight=medium`}
              >
                <img
                  src="https://aelftmmytfogebtinoid.supabase.co/storage/v1/object/public/mvp//jotunheimen.png"
                  width="225"
                  height="225"
                  alt="AR Model Preview"
                />
              </a>
            </div>
            <div className="ar-image-container">
            <a rel="ar" id="CustomAction" href="https://aelftmmytfogebtinoid.supabase.co/storage/v1/object/public/mvp//vdc_sculpture.usdz#callToAction=En%20voir%20+&checkoutTitle=Oeuvre%20digitalis%C3%A9e%20par%20Prophecy&checkoutSubtitle=Guerrier%20du%20désert%20de%20Paul%20Beckrich">
                <img src="https://aelftmmytfogebtinoid.supabase.co/storage/v1/object/public/mvp//guerrier_sable.png" width="150" height="350"/>
              </a>
            </div>
            <div className="ar-image-container">
            <a rel="ar" id="CustomAction" href="https://aelftmmytfogebtinoid.supabase.co/storage/v1/object/public/mvp//hopare.usdz#callToAction=En%20voir%20+&checkoutTitle=Oeuvre%20digitalis%C3%A9e%20par%20Prophecy&checkoutSubtitle=Oeuvre%20de%20Hopare">
                <img src="https://aelftmmytfogebtinoid.supabase.co/storage/v1/object/public/mvp//hopare.png" width="150" height="350"/>
              </a>
            </div>
            <div className="ar-image-container">
            <a rel="ar" id="CustomBanner3" href="https://aelftmmytfogebtinoid.supabase.co/storage/v1/object/public/mvp//perroquet.usdz#custom=https://axxou.github.io/host_html2/&customHeight=medium">
                <img src="https://aelftmmytfogebtinoid.supabase.co/storage/v1/object/public/mvp//perroquet.jpg" width="210" height="210"/>
              </a>
            </div>
          </div>
        </div>

        <div className="ar-cta">
          <Link to="/" className="back-link">
            <button className="back-button">Retour à la page d'accueil</button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ExampleAR;